"use client";

import { useHeaderContext } from "./header.context";
import type { HeaderMobileMenuProps } from "./types/header-mobile-menu.types";
import { headerMobileMenuStyles, headerMobileMenuContentStyles } from "./styles/header-mobile-menu.styles";
import { useEffect, useMemo } from "react";

export const HeaderMobileMenu: React.FC<HeaderMobileMenuProps> = (props) => {
  const { children, className, ...rest } = props;

  const { menuOpen } = useHeaderContext();

  const inertProps = useMemo(() => {
    return !menuOpen ? { inert: true } : {};
  }, [menuOpen]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    document.body.classList.toggle("overflow-hidden", menuOpen);
  }, [menuOpen]);

  return (
    <div className={headerMobileMenuStyles({ className, menuOpen })} {...inertProps} {...rest}>
      <div className={headerMobileMenuContentStyles()}>{children}</div>
    </div>
  );
};

HeaderMobileMenu.displayName = "HeaderMobileMenu";
